import { render, staticRenderFns } from "./HeroWedding.vue?vue&type=template&id=eebfa5da&scoped=true&"
import script from "./HeroWedding.vue?vue&type=script&lang=js&"
export * from "./HeroWedding.vue?vue&type=script&lang=js&"
import style0 from "./HeroWedding.vue?vue&type=style&index=0&id=eebfa5da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebfa5da",
  null
  
)

export default component.exports